import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ITask } from '@nimbus-assistant/models/task.model';
import { TranslationKeys } from '@nimbus-library/features/localization/models/enums/translation-keys.enum';
import { FooterInfoComponent } from '../shared/info/footer-info.component';
import { FooterActionsComponent, TaskActionsMode } from '../shared/actions/footer-actions.component';

@Component({
  standalone: true,
  selector: 'app-footer-incoming',
  templateUrl: './footer-incoming.component.html',
  styleUrls: ['./footer-incoming.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FooterInfoComponent, FooterActionsComponent],
})
export class FooterIncomingComponent {
  @Input({ required: true }) public task: ITask;

  public readonly statusText = TranslationKeys.QueueIncoming;
  public readonly TaskActionsMode = TaskActionsMode;
}
